import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import {showToast} from '../../components/toasts/index.jsx'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './styles/tabs.css';
import Weekly from './pages/Weekly';
import Fleet from './pages/Fleet';
import Driver from './pages/Driver';
import Site from './pages/Site';
import Axios from 'axios';
import { selectStyles, multiSelectStyles, midMultiSelectStyles, comparisonOptions } from './components/helpers/selectFormHelper';
import { transformConsolidatedTotals, transformFleetTotals, transformFleetTrips } from './components/helpers/paymentsHelper';
import { 
  transformDriverBreakdown,
  transformTripBreakdown,
  transformRideshareBreakdown,
  transformIncentiveBreakdown,
  transformPaymentBreakdown,
  transformFleetBalance 
} from './components/helpers/driverHelper';

function Payments({ fleets,companies, params, current_user }) {
  const isAdmin = current_user?.role === 'admin';
  const isLogisticsSpecialist = current_user?.role === 'logistics_specialist';  
  const [selectedComparison, setSelectedComparison] = useState({ value: '1', label: '1 week' });
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); 
  const [consolidatedTotals, setConsolidatedTotals] = useState({});
  const [fleetTrips, setFleetTrips] = useState({});
  const [siteOverview, setSiteOverview] = useState({});
  const [fleetTotals, setFleetTotals] = useState({});
  const [weeklyData, setWeeklyData] = useState([]);

  // driver states
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    // const [selectedFleets, setSelectedFleets] = useState([]);
    const [isStatementsModalOpen, setStatementsModalOpen] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [driverTable, setDriverTable] = useState([]);
    const [fleetData, setFleetData] = useState(null);
    const [paymentBreakdown, setPaymentBreakdown] = useState({});
    const [tripBreakdown, setTripBreakdown] = useState({});
    const [incentiveBreakdown, setIncentiveBreakdown] = useState({});
    const [fleetBalance, setFleetBalance] = useState({});
    const [rideshareBreakdown, setRideshareBreakdown] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    
    const [selectedRows, setSelectedRows] = useState([]);
  
  
    const [itemLoad, setItemLoad] = useState(false);
    const [editMode, setEditMode] = useState({});
    const [editedValues, setEditedValues] = useState({});
  
  const [uploadErrors, setUploadErrors] = useState([]);
  // eof driver states

  const [week, setWeek] = useState({
    from: params.start_date_filter,
    to: params.end_date_filter,
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: '',
  });

  const ALL_OPTION = { label: "Select fleet", value: "__ALL__" };
  const [fleetTabFleet, setFleetTabFleet] = useState(ALL_OPTION);
  const [driverTabFleets, setDriverTabFleets] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const fleetOptions = React.useMemo(() => {
    const base = fleets.map(f => ({ label: f.name, value: f.id }));
    return [ALL_OPTION, ...base];
  }, [fleets]);

  const toOptionObjects = React.useCallback((arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return [];

    if (typeof arr[0] === "object" && arr[0] !== null && "value" in arr[0]) {
      const ids = new Set(arr.map(o => o.value));
      return fleetOptions.filter(o => ids.has(o.value));
    }

    const idSet = new Set(arr);
    return fleetOptions.filter(o => idSet.has(o.value));
  }, [fleetOptions]);

  const buildDriverFleetsPayload = () => {
    const pickedAll = driverTabFleets?.some(o => o.value === "__ALL__");
    if (pickedAll) {
      return fleets.map(f => ({ value: f.id, label: f.name }));
    }
    return (driverTabFleets || []).map(o => ({ value: o.value, label: o.label }));
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const { data } = await Axios.post("/weekly_account_snapshots/weekly_summary", {
        selected_week: week.from,
        comparison_period: selectedComparison.value,
      });

      const filteredData = data.company_data.filter(company => company !== null);

      setWeeklyData(filteredData);
      setConsolidatedTotals(transformConsolidatedTotals(data))

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      showToast("error", 'Error fetching fleet payments')
    }
    setLoading(false);
  };

  const fetchFleetOverview = async () => {
    setLoading(true);
    try {
      const { data } = await Axios.post("/weekly_account_snapshots/fleet_summary", {
        selected_week: week.from,
        user_fleets: fleetTabFleet,
        user_companies: selectedCompanies
      });

      // const filteredData = data.company_data.filter(company => company !== null);

      setWeeklyData(data.fleet_overview);
      setFleetTrips(transformFleetTrips(data))
      setFleetTotals(transformFleetTotals(data))

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      showToast("error", 'Error fetching fleet payments')
    }
    setLoading(false);
  };

  const fetchSiteOverview = async (page) => {
    setLoading(true);
    try {
      const { data } = await Axios.post("/payments/site_overview", {
        selected_week: week.from,
        user_company: selectedCompanies,
        page: page
      });

      if (page === 1) {
        setSiteOverview(data);
      } else {
        setSiteOverview(prev => ({ ...prev, ...data }));
        // setSiteOverview(prev => ({
        //   ...prev,
        //   [page]: response.data, // Store each page's data under its number
        // }));
      }
      // const filteredData = data.company_data.filter(company => company !== null);

      // setSiteOverview(data);

      setCurrentPage(data.current_page);
      setHasMore(!!data.next_page);

    } catch (error) {
      console.error("Error fetching site information:", error);
      showToast("error", 'Error fetching fleet payments')

    }
    setLoading(false);
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    if (!siteOverview[nextPage]) {
      fetchSiteOverview(nextPage);
    }
  };
  
  const handleBack = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      if (!siteOverview[prevPage]) {
        fetchSiteOverview(prevPage);
      }
    }
  };

  const fetchApprovalFlag = async (approval_flag) => {
    setLoading(true);
    try {
      await Axios.post("/payments/admin_approval_lock", {
        approval_flag: approval_flag,
        user_company: selectedCompanies,
        selected_week: week.from,
      });
      await fetchSiteOverview(currentPage);
    } catch (error) {
      console.error("Error:", error);
      showToast("error", "Failed to update approval status.");
    } finally {
      setLoading(false);
    }
  };

  const updateSiteOverviewTrips = async (id, formData) => {
    setLoading(true);
    try {
      await Axios.put(`/payments/grouped_trip_updates/${id}`, formData);
    } catch (error) {
      console.error("Error updating driver:", error);
      showToast("error", 'Failed to update driver.')
    }

    fetchSiteOverview(currentPage);
  };

  const downloadSiteCsv = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_site_csv", 
        {
          user_company: selectedCompanies,
          download_week: week.from
        }
      );

      setLoading(false);
      showToast("success", `${response.data.message}`)
    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      setLoading(false)
      showToast("error", 'Download Failed!')
    }
  };

  const downloadDriverCsv = async (selectedWeek) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_driver_csv",
        {
          user_fleets: buildDriverFleetsPayload(),
          download_week: selectedWeek.from
        }
      );

      setLoading(false);
      showToast("success", `${response.data.message}`)
    } catch (error) {
      setLoading(false);
      showToast("error", 'Download Failed!')
    }
  };

  const downloadXeroCsv = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_xero_csv",
        {
          user_company: selectedCompanies,
          download_week: week.from
        }
      );

      showToast("success", response.data.message);
    } catch (error) {
      showToast("error", error.response?.data?.error ?? "Download Failed!");
    } finally {
      setLoading(false);
    }
  };  
  
  const handleChange = (selectedValue) => {
    setSelectedComparison(selectedValue);
    setSelectedOption(selectedValue);
  };


  // DRIVER OVERVIEW


  
  const fetchFleetPayments = async () => {
    try {
      const { data } = await Axios.post("/weekly_account_snapshots/driver_summary", {
        user_fleets: buildDriverFleetsPayload(),
        selected_week: week.from
      });

      const serverSelected = data?.selected_fleets;
      if (Array.isArray(serverSelected)) {
        const normalized = toOptionObjects(serverSelected);
        if (normalized.length === fleets.length && fleets.length > 0) {
          setDriverTabFleets([ALL_OPTION]);
        } else {
          setDriverTabFleets(normalized);
        }
      }

      setFleetData(transformDriverBreakdown(data));
      setTripBreakdown(transformTripBreakdown(data));
      setPaymentBreakdown(transformPaymentBreakdown(data));
      setFleetBalance(transformFleetBalance(data));
      setIncentiveBreakdown(transformIncentiveBreakdown(data));
      setRideshareBreakdown(transformRideshareBreakdown(data));
      setDriverTable(data.driver_table);

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      alert("Error fetching fleet payments:", error);
    }
  };

  // EntityMultiSelect adapter for Driver Overview tab
  const entitySelectedFleets = React.useMemo(() => {
    const pickedAll = driverTabFleets?.some(o => o.value === "__ALL__");
    if (pickedAll) return [...fleets];
    const selectedIds = new Set(driverTabFleets.map(o => o.value));
    return fleets.filter(f => selectedIds.has(f.id));
  }, [driverTabFleets, fleets]);

  const onEntityFleetChange = React.useCallback((items) => {
    if (!items || items.length === 0) {
      setDriverTabFleets([]);
      return;
    }
    if (items.length === fleets.length) {
      setDriverTabFleets([ALL_OPTION]);
    } else {
      setDriverTabFleets(items.map(f => ({ value: f.id, label: f.name })));
    }
  }, [fleets]);

  const handleUpdateAll = async () => {
    const editedSnapshotIds = Object.keys(editMode).filter(
      (snapshotId) => editMode[snapshotId]
    );
  
    setItemLoad(true);
    try {
      await Promise.all(
        editedSnapshotIds.map((id) =>
          Axios.put(`/weekly_account_snapshots/manual_update_snapshot/${id}`, editedValues[id])
        )
      );
      setEditMode((prev) => {
        const newEditMode = { ...prev };
        editedSnapshotIds.forEach((id) => {
          newEditMode[id] = false;
        });
        return newEditMode;
      });
    } catch (error) {
      console.error("Error updating snapshots:", error);
      showToast("error", 'Failed to update some snapshots.')
    }
    setItemLoad(false);
    setLoading(true);
  };

  const handleSaveClick = async (accountId) => {
    setItemLoad(true);
    try {
      await Axios.put(`/weekly_account_snapshots/manual_update_snapshot/${accountId}`, editedValues[accountId]);
      setEditMode((prev) => ({ ...prev, [accountId]: false }));
      showToast("success", 'Updated driver');
    } catch (error) {
      console.error("Error updating driver:", error);
      showToast("error", 'Failed to update driver.')
    }
    setItemLoad(false);
    setLoading(true);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('bonuses_file', selectedFile);

    setModalLoading(true);

    try {
      const response = await Axios.post(
        "/weekly_account_snapshots/upload_csv",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
          }
        }
      );

      setSelectedFile(null);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';

      const { message, errors, updated_count: updatedCount } = response.data ?? {};
      if (errors?.length) {
        setUploadErrors(errors);
        showToast(errors.length && !updatedCount ? "error" : "warning", message || 'Upload finished with errors.');
      } else {
        setUploadErrors([]);
        showToast("success", message ?? 'Upload Successful!');
      }
      setLoading(true);
    } catch (error) {
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      setSelectedFile(null);
      const data = error.response?.data;
      const msg = typeof data === 'string' ? data : data?.message;
      setUploadErrors(data?.errors || []);
      showToast("error", msg || 'Upload failed.');
    } finally {
      setModalLoading(false);
    }
  };

  const downloadPdf = async () => {
    setModalLoading(true);
    try {
      const response = await Axios.get('/weekly_account_snapshots/print_driver_statement', {
        params: {selected_rows: selectedRows, statement_week: week.from},
        responseType: 'json',
        headers: {
          Accept: 'application/json',
        },
      });
      showToast("success", response.data?.message ?? 'The statement has been sent to your email address.');
    } catch (error) {
      showToast("error", error.response.data?.message ?? 'Error requesting driver statement');
    }
    setModalLoading(false);
  }

  const downloadFleetStatement = async (week_number) => {
    setLoading(true);

    const download_value = (week_number === 1)
      ? week.from
      : weeklyData.download_previous;

    try {
      const response = await Axios.get('/weekly_account_snapshots/print_fleet_pdf', {
        params: {
          selected_fleets: fleetTabFleet,
          statement_week: download_value,
        },
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      });
      showToast("success", response.data?.message ?? 'The statement has been sent to your email address.');
    } catch (error) {
      showToast("error", error.response.data?.message ?? 'Error requesting fleet statement');
    }
    setLoading(false);
  }

  const downloadTemplate = async () => {
    setModalLoading(true);
    try {
      const response = await Axios.post(
        "/weekly_account_snapshots/download_csv",
        {
          user_fleets: buildDriverFleetsPayload(),
          download_week: week.from
        }, 
        {
          headers: {
            'Accept': 'text/csv',
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        }
      );

      setModalLoading(false);
      showToast("success", `${response.data.message}`)
    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      setModalLoading(false)
      showToast("error", 'Download Failed!')
    }
  };

  const resetDriverState = () => {
    setSelectedWeek(null);
    setDriverTabFleets([]);
    setFleetData(null)
    setDriverTable([]);
    setPaymentBreakdown({});
    setTripBreakdown({});
    setIncentiveBreakdown({});
  };

  
  // EOF DRIVER OVERVIEW


  return (
    <>
      <div className="flex w-full mb-2 justify-between">
        <div className="text-xl font-medium text-gray-700">
          <div className="flex flex-row">
            <h3 className="">Payments</h3>
          </div>
          <p className="text-sm text-gray-500">
            Logged in as {current_user.name} {current_user.surname}
          </p>
        </div>
      </div>
      <Tabs
        style={{
          boxShadow:
            '-4px 4px 6px rgba(0, 0, 0, 0.05), 4px 4px 6px rgba(0, 0, 0, 0.05),0 4px 6px rgba(0, 0, 0, 0.05)',
          paddingleft: '10px',
          paddingRight: '0px',
          borderRadius: '15px 15px 0 0',
          backgroundColor: 'white',
        }}>
        {/* Tab headings */}
        <TabList
          style={{ display: 'flex', width: '100%', borderBottom: 'none' }}
        >
          {isAdmin && (
            <>
              <Tab className="tab" selectedClassName="tab--selected">
                Weekly Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Company Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Fleet Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Driver Overview
              </Tab>
            </>
          )}

          {isLogisticsSpecialist && (
            <Tab className="tab" selectedClassName="tab--selected">
              Company Overview
            </Tab>
          )}
        </TabList>

        {isAdmin && (
          <>
            {/* Tab 1: Weekly Overview */}
            <TabPanel style={{ background: 'white' }}>
              <div className="tabs-tab-panel">
                <Weekly
                  loading={loading}
                  selectStyles={selectStyles}
                  data={weeklyData}
                  setData={setWeeklyData}
                  handleChange={handleChange}
                  comparisonOptions={comparisonOptions}
                  week={week}
                  setWeek={setWeek}
                  fetchCompanies={fetchCompanies}
                  selectedOption={selectedOption}
                  consolidatedTotals={consolidatedTotals}
                  selectedComparison={selectedComparison}
                />
              </div>
            </TabPanel>

            {/* Tab 2: Company Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Site
                  loading={loading}
                  selectStyles={selectStyles}
                  multiSelectStyles={multiSelectStyles}
                  midMultiSelectStyles={midMultiSelectStyles}
                  handleChange={handleChange}
                  companies={companies}
                  params={params}
                  week={week}
                  setWeek={setWeek}
                  selectedCompanies={selectedCompanies}
                  setSelectedCompanies={setSelectedCompanies}
                  fetchSiteOverview={fetchSiteOverview}
                  siteOverview={siteOverview}
                  setSiteOverview={setSiteOverview}
                  updateSiteOverviewTrips={updateSiteOverviewTrips}
                  downloadSiteCsv={downloadSiteCsv}
                  downloadXeroCsv={downloadXeroCsv}
                  toast={toast}
                  setToast={setToast}
                  styles={selectStyles}
                  fetchApprovalFlag={fetchApprovalFlag}
                  currentPage={currentPage}
                  hasMore={hasMore}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  isAdmin={isAdmin}
                />
              </div>
            </TabPanel>

            {/* Tab 3: Fleet Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Fleet
                  fleets={fleets}
                  comparisonOptions={comparisonOptions}
                  loading={loading}
                  companies={companies}
                  params={params}
                  handleChange={handleChange}
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  selectStyles={selectStyles}
                  selectedFleet={fleetTabFleet}
                  setSelectedFleet={setFleetTabFleet}
                  defaultSelectedFleet={ALL_OPTION}
                  selectedCompanies={selectedCompanies}
                  setSelectedCompanies={setSelectedCompanies}
                  fetchFleetOverview={fetchFleetOverview}
                  data={weeklyData}
                  fleetTrips={fleetTrips}
                  fleetTotals={fleetTotals}
                  week={week}
                  setWeek={setWeek}
                  multiSelectStyles={multiSelectStyles}
                  downloadFleetStatement={downloadFleetStatement}
                />
              </div>
            </TabPanel>

            {/* Tab 4: Driver Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Driver
                  fleets={fleets}
                  week={week}
                  setWeek={setWeek}
                  selectStyles={selectStyles}
                  midMultiSelectStyles={midMultiSelectStyles}
                  fetchFleetPayments={fetchFleetPayments}
                  loading={loading}
                  setLoading={setLoading}
                  entitySelectedFleets={entitySelectedFleets}
                  onEntityFleetChange={onEntityFleetChange}
                  handleSaveClick={handleSaveClick}
                  handleUpdateAll={handleUpdateAll}
                  downloadPdf={downloadPdf}
                  handleUpload={handleUpload}
                  downloadTemplate={downloadTemplate}
                  selectedWeek={selectedWeek}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  modalLoading={modalLoading}
                  isStatementsModalOpen={isStatementsModalOpen}
                  setStatementsModalOpen={setStatementsModalOpen}
                  dropdown={dropdown}
                  setDropdown={setDropdown}
                  driverTable={driverTable}
                  fleetData={fleetData}
                  paymentBreakdown={paymentBreakdown}
                  tripBreakdown={tripBreakdown}
                  incentiveBreakdown={incentiveBreakdown}
                  fleetBalance={fleetBalance}
                  rideshareBreakdown={rideshareBreakdown}
                  setSelectedFile={setSelectedFile}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  itemLoad={itemLoad}
                  editMode={editMode}
                  setEditMode={setEditMode}
                  editedValues={editedValues}
                  setEditedValues={setEditedValues}
                  toast={toast}
                  resetDriverState={resetDriverState}
                  downloadDriverCsv={downloadDriverCsv}
                  uploadErrors={uploadErrors}
                  clearUploadErrors={() => setUploadErrors([])}
                />
              </div>
            </TabPanel>
          </>
        )}

        {isLogisticsSpecialist && (
          <TabPanel>
            <div className="tabs-tab-panel">
              <Site
                loading={loading}
                selectStyles={selectStyles}
                multiSelectStyles={multiSelectStyles}
                midMultiSelectStyles={midMultiSelectStyles}
                handleChange={handleChange}
                companies={companies}
                params={params}
                week={week}
                setWeek={setWeek}
                selectedCompanies={selectedCompanies}
                setSelectedCompanies={setSelectedCompanies}
                fetchSiteOverview={fetchSiteOverview}
                siteOverview={siteOverview}
                setSiteOverview={setSiteOverview}
                updateSiteOverviewTrips={updateSiteOverviewTrips}
                downloadSiteCsv={downloadSiteCsv}
                downloadXeroCsv={downloadXeroCsv}
                toast={toast}
                setToast={setToast}
                styles={selectStyles}
                fetchApprovalFlag={fetchApprovalFlag}
                currentPage={currentPage}
                hasMore={hasMore}
                handleNext={handleNext}
                handleBack={handleBack}
                isAdmin={isAdmin}
              />
            </div>
          </TabPanel>
        )}
      </Tabs>
      <ToastContainer position="bottom-right" />
    </>
  );
}

export default Payments;
